var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { FirebaseAuthContext } from 'libs.firebase_react';
import { useLocalizeMessage, useToastNotification } from 'libs.nucleus';
import { ApiClientService, useApiClient } from 'libs.react_internal';
export function useStudyL10nMap() {
    const { post } = useApiClient(ApiClientService.CLOUD);
    const { addNotification } = useToastNotification();
    const translate = useLocalizeMessage();
    const { firebaseToken } = useContext(FirebaseAuthContext);
    const { mutate: setStudyL10nMap, isPending, isError, } = useMutation({
        mutationKey: ['translation', 'studyL10nMap'],
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ studyId, currentL10nMapId, assetLocaleVersionSet, pruneMappingByAssets = false, }) {
            if (!firebaseToken) {
                addNotification({
                    title: translate('Network error: please try again in a moment'),
                    type: 'error',
                });
                return;
            }
            const data = { studyId, currentL10nMapId, assetLocaleVersionSet, pruneMappingByAssets };
            return yield post(`/translation/study_l10n_map`, data, {
                // Pass firebase token and medable token as well
                withCredentials: false,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${firebaseToken}`,
                },
            });
        }),
        onError: (error) => {
            console.error(error);
        },
        retry: 1,
    });
    return {
        setStudyL10nMap,
        isPending,
        isError,
    };
}
//# sourceMappingURL=study_l10n_map.hook.js.map